/** @format */

import React, { useState, useEffect, useRef } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../css/PDPA.css";

export default function PDPA(props) {
  const [expand, setExpand] = useState(false);
  return (
    <div
      style={{
        backgroundColor: "rgb(238 238 238 / 62%)",
        marginTop: "2rem",
        marginBottom: "5rem",
        width: "fit-content",
        padding: "0.2rem 1rem",
      }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
        onClick={() => setExpand(!expand)}>
        {!expand ? (
          <svg
            class="w-6 h-6 text-gray-800 dark:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24">
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m8 10 4 4 4-4"
            />
          </svg>
        ) : (
          <svg
            class="w-6 h-6 text-gray-800 dark:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24">
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m16 14-4-4-4 4"
            />
          </svg>
        )}

        <p className="txt-txt title-pdpa" style={{ cursor: "pointer" }}>
          Consent for Data Collection/Usage/Disclosure
        </p>
      </div>

      {expand && (
        <div style={{ marginLeft: "0.5rem" }}>
          <p className="txt-txt sub-title-pdpa">
            Traffy Fondue NSTDA prioritizes privacy and therefore requests
            consent for the collection, use, and/or disclosure of information
            that you provide or that is obtained from other sources, such as
            text messages, images, and location coordinates, for the following
            purposes:
          </p>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              margin: "1rem 0",
            }}>
            <p className="txt-txt sub-title-pdpa">
              1. To compile and submit information to relevant agencies for
              consideration and problem-solving according to their authority and
              duties.
            </p>
            <p className="txt-txt sub-title-pdpa">
              2. To use for service system development and for analysis and
              research in the laboratory.
            </p>
            <p className="txt-txt sub-title-pdpa">
              3. To display data without identifying the reporter on a public
              website accessible to the general public.
            </p>
          </div>
          <p className="txt-txt sub-title-pdpa">
            Users have the right to withdraw their consent at any time via Line@
            Traffy Fondue Help.
          </p>
        </div>
      )}
    </div>
  );
}
